import React, { useImperativeHandle, forwardRef } from 'react'
import { Form, Input, Button, Select, Row, Col, DatePicker } from 'antd'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

interface IProps {
  onQuery?: (value: any) => void
  sourceOptions?: any[]
}

const QueryForm = ({ onQuery, sourceOptions = [] }: IProps, ref: any) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const { RangePicker } = DatePicker
  const onFinish = (values: any) => {
    if (values.updateTime) {
      values.startTime = dayjs(values.updateTime[0]).format(
        'YYYY-MM-DD 00:00:00'
      )
      values.endTime = dayjs(values.updateTime[1]).format('YYYY-MM-DD 23:59:59')
      delete values.updateTime
    }
    if (values.source) {
      values.source = values.source.join('||')
    }
    typeof onQuery === 'function' && onQuery(values)
  }
  const onReset = () => {
    form.resetFields()
    typeof onQuery === 'function' && onQuery({})
  }
  useImperativeHandle(ref, () => {
    return {
      resetQuery: onReset,
      submitQuery: () => form.submit(),
    }
  })
  return (
    <Form
      form={form}
      layout="inline"
      onFinish={onFinish}
      labelCol={{
        span: 6,
      }}
      labelAlign="left"
      autoComplete="off"
    >
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Form.Item label={t('knowledge.txt10')} name="normalName">
            <Input placeholder={t('ikg.input', { name: t('knowledge.txt10') })} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('knowledge.txt11')} name="tradeName">
            <Input placeholder={t('ikg.input', { name: t('knowledge.txt11') })} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('knowledge.txt12')} name="englishName">
            <Input placeholder={t('ikg.input', { name: t('knowledge.txt12') })} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('knowledge.txt13')} name="activeIngredient">
            <Input placeholder={t('ikg.input', { name: t('knowledge.txt13') })} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('knowledge.txt17')} name="approvalNo">
            <Input placeholder={t('ikg.input', { name: t('knowledge.txt17') })} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('knowledge.txt18')} name="drugStandardCode">
            <Input placeholder={t('ikg.input', { name: t('knowledge.txt18') })} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label={t('knowledge.txt14')}
            name="manufacturer"
          >
            <Input placeholder={t('ikg.input', { name: t('knowledge.txt14') })} />
          </Form.Item>
        </Col>
        <Col span={8}></Col> 
        <Col span={8}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: 16,
            }}
          >
            <Button onClick={onReset}>{t('ikg.reset')}</Button>
            <Button type="primary" onClick={() => form.submit()} ghost>
              {t('ikg.query')}
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  )
}

export default forwardRef(QueryForm)
